import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';

import { User }  from '../user/user';
import { Api }   from '../api/api';
import { Utils } from '../utils/utils';
import { IPTV }  from '../iptv/iptv';


/*
*
*  Fav (Favorite but the name is already taken by page) Provider
*
*/

@Injectable()
export class FavApp {

    public data: any = [];
    public empty : boolean;
    public isLoading : boolean = false;

    constructor(
        public events: Events,
        public user: User,
        public api: Api,
        public IPTV: IPTV,
        public utils: Utils
    ) {
        this.events.subscribe('app:refresh', (params : any = {}) => { 
            this.fetch(true, true);
        });

        this.events.subscribe('favoriteApp:refreshCache', (params : any = {}) => { 
            this.fetch(true, true);
        })
        
    }

    getFavoritesApp(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {
            this.api.getCached('iptv/favoriteapp', { writeCache:writeCache }).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
       });
    }

    fetch(noLoading:boolean=false, writeCache:boolean=false) {
        if(!noLoading) this.isLoading = true;
        if(!noLoading) this.utils.load();
        this.getFavoritesApp(writeCache).then((data : any = []) => {

            if (data.length) {
                this.data  = this.prepareData(data);
                this.empty = false;
            } else {
                this.empty = true;
            }

            if(!noLoading) this.isLoading = false;
            if(!noLoading) this.utils.unload();
        });
    }

    fetchPromise() {
        return new Promise((resolve, reject) => {
            this.getFavoritesApp(true).then((data : any = []) => {
                this.data   = this.prepareData(data);

                if (data.length) {
                    this.empty = false;
                } else {
                    this.empty = true;
                }
    
                resolve();
            }, (err) => {
                reject(err);
            });
        });
    }


    prepareData(data) {
        let array = [];

        for(let _app of data) {
            this.utils.checkApplication(_app).then((response) => {
                array.push(_app);
            }, (err) => {});
        }

        return array;
    }

    toggle(application) {
        if (application.fav) {
            this.delete(application);
        } else {
            this.add(application);
        }
    }

    add(application) {
         let that = this;
        this.utils.confirm({message: 'Add '+application.name+' to favorite ?'}, function() {
            that.utils.load();

            that.api.post('iptv/favoriteapp/'+application.id).subscribe((response:any)=>{
                that.fetchPromise().then((data : any = []) => {
                    that.events.publish('favoriteapp:refresh');
                    setTimeout(function() {
                        that.utils.success('Successfuly added to your favorite');
                        application.fav = true;
                        that.utils.unload();
                    }, 500);
                });
            },(err) => {
                that.utils.error(this.api.reject(err));
                that.utils.unload();
            });
        });
    }

    delete(application) {

        
        let that = this;
        this.utils.confirm({message: 'Remove '+application.name+' from favorite ?'}, function() {
            
            that.utils.load();
            that.api.delete('iptv/favoriteapp/'+application.id).subscribe((response:any)=>{  

                that.fetchPromise().then((data : any = []) => {
                    that.events.publish('favoriteapp:refresh');
                    setTimeout(function() {
                        that.utils.success('Successfuly removed from your favorite');
                        application.deleted = true;
                        that.utils.unload();
                    }, 500);
                });
                
            },(err) => {
                that.utils.error(this.api.reject(err));
                
            });
        }, function() {
            that.utils.unload();
        });
        
    }



}


// WEBPACK FOOTER //
// ./src/providers/favapp/favapp.ts